import styles from './styles.less';

// Module
import routes from './routes';

export default angular.module( 'app.main.account.settings.module',
    [] )
    .config(routes)
    .name



/** WEBPACK FOOTER **
 ** ./src/main/account/settings/index.js
 **/